import React from 'react'

import { hooks } from '@front/volcanion'
import { TimeUtils } from '@front/volcanion/utils'
import { OrderLink } from '@abra/elements'
import { TextCell } from '@abra/elements/table/cells/basics/'

import moment from 'moment'
import { TableCell } from '@mui/material'

const Row = ({ row }) => {
  const [{ name: user_name }] = hooks.useCustomerInfo(row?.do?.user_id)
  const requestedAt = moment.utc(TimeUtils.getDetailsMomentFront(row?.requestedAt, row?.source)).local().format('DD/MM/YYYY HH:mm')
  return (
    <>
      <TableCell padding='none'>
        <OrderLink record_id={row?.order_id} />
      </TableCell>
      <TableCell padding='none'>
        <TextCell fontSize={15} value={requestedAt} />
      </TableCell>
      <TableCell padding='none'>
        <TextCell fontSize={15} value={!!row?.service ? row?.service?.contract?.formula.name : row?.do?.commercial_formula?.name} />
      </TableCell>
      <TableCell padding='none'>
        <TextCell fontSize={15} value={user_name} />
      </TableCell>
      <TableCell padding='none'>
        <TextCell fontSize={15} value={row?.source?.name} />
      </TableCell>
      <TableCell padding='none'>
        <TextCell fontSize={15} value={row?.destination?.name} />
      </TableCell>
    </>
  )
}

export default React.memo(Row)
